import { Component, OnInit } from '@angular/core';
import { AppInformationService, AuthService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { AchTransaction, Order } from 'app/core/model/entity-model';
import { SharedModule } from 'app/shared/shared.module';
import { default as validationEngine } from 'devextreme/ui/validation_engine';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { confirm } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-ach-transaction-dialog',
    templateUrl: './ach-transaction-dialog.component.html',
    styleUrls: ['./ach-transaction-dialog.component.scss'],
    standalone: false
})
export class AchTransactionDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    achTransaction: AchTransaction;
    achId: number;
    dealerId: number;
    invoices: any;
    validationGroup = 'mainValidationGroup';
    errorAction = 'submitting';
    canEditAmount: boolean = false;

    onExporting = SharedModule.onExporting;

    constructor(public modalRef: BsModalRef, private uow: GenesisUnitOfWork, private appInfo: AppInformationService, private auth: AuthService, private utility: UtilityService) {}

    async ngOnInit() {
        await this.getInvoices();
        this.canEditAmount = this.achTransaction?.ach.type !== 'Invoice';
        if (!this.achTransaction) {
            this.achTransaction = this.uow.achTransactions.createEntity({
                achId: this.achId,
                created: new Date(),
                createdBy: this.auth.currentUser?.userName,
                transferInitiated: new Date(),
                transferInitiatedBy: this.auth.currentUser?.userName,
            });
        }
        else {
            if (this.achTransaction.transferInitiatedBy === null) {
                this.achTransaction.transferInitiated = new Date();
                this.achTransaction.transferInitiatedBy = this.auth.currentUser?.userName;
            }
        }
    }

    async getInvoices() {
        this.invoices = await this.uow.getOpenInvoices('dealer', { dealerId: this.dealerId });
    }

    async save() {
        const success = await Promise.resolve(this.validate());
        if (!success) return;

        await this.uow.commit();
        this.result.next({ success: true, value: this.achTransaction });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }

    close() {
        this.achTransaction.entityAspect.rejectChanges();
        this.result.next({ success: false });
    }
}
